import { datadogLogs } from '@datadog/browser-logs';

// eslint-disable-next-line import/prefer-default-export
export const getoloFunnelPublicAPI = ({ root, shadowRoot }) => {
  window.getoloFunnelApp = window.getoloFunnelApp || {};

  // method to unmount the funnel app
  window.getoloFunnelApp.unmount = (args) => {
    const { removeHost } = args || {};

    if (!root) return;

    try {
      root?.unmount();

      if (removeHost && shadowRoot?.host) {
        shadowRoot.host?.remove();
      }
    } catch (error) {
      datadogLogs.logger.warn('Failed to unmount getolo funnel', { error });
    }
  };
};
